import { memo, useCallback } from 'react';

import { type Board } from '@air/api/types';

import { PublicCopyrightSelect } from '~/components/Filters/CopyrightFilter/components/PublicCopyrightSelect';
import { type BaseFilterCardProps } from '~/components/Filters/FilterCard';
import { StringArrayFilterCard } from '~/components/Filters/StringArrayFilterCard';
import { type BaseStringSelectProps } from '~/components/StringSelect';

export type PublicCopyrightFilterCardProps = {
  boardId: Board['id'] | undefined;
} & BaseFilterCardProps;

export const PublicCopyrightFilterCard = memo(({ boardId, ...props }: PublicCopyrightFilterCardProps) => {
  const renderCopyrightSelect = useCallback(
    (props: BaseStringSelectProps) => <PublicCopyrightSelect {...props} boardId={boardId} />,
    [boardId],
  );

  return (
    <StringArrayFilterCard
      filter="copyrights"
      filterCardType="copyright"
      StringSelect={renderCopyrightSelect}
      {...props}
    />
  );
});

PublicCopyrightFilterCard.displayName = 'PublicCopyrightFilterCard';
